
export const environment = {
    APP_TYPE: process.env.REACT_APP_TYPE,
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    APP_BUSINESS_URL: process.env.REACT_APP_BUSINESS_URL,
    // If CHAIN_ID is not set in the environment, default to Goerli (5)
    CHAIN_ID: process.env.REACT_APP_BLOCKCHAIN_CHAIN_ID !== undefined ? process.env.REACT_APP_BLOCKCHAIN_CHAIN_ID : '5'
}